module.exports = __webpack_public_path__ + "img/frame_camerafeed.b196976f.svg";